export const getLoyaltyOrderItemPoints = (state) => {
  return state.CustomerLoyaltyReducer && state.CustomerLoyaltyReducer?.get('loyaltyOrderItemPoints');
};

export default getLoyaltyOrderItemPoints;
